import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import {
  AcceptIcon,
  ActionableNotificationNoDataIcon,
  AllNotificationNoDataIcon,
  ChatNoData,
  DocumetsNotificationNoDataIcon,
  POChangesNoData,
  ResponceNotificationNoDataIcon,
} from '../icons/icons';
import './global-notification.scss';
import { UPDATE_ORDERITEMS } from '../../graphQL/orderDetailsPage';
import { MUTATION_BOOKING_ACCEPT_REJECT } from '../../graphQL/bookingList';
import URLConst from '../../service/URLConst';
import Skeleton from '../skeleton/skeleton';
import NoData from '../no-data/no-data';
import http from '../../service/APIUtil';
import { tokenGeneration } from '../../service/authService';
import { readChannelNotifications } from '../../service/chatAPIHandler';
import OutsideClick from '../outside-click/outside-click';
import DocumentItem from './document-item';
import PoChangesGroup from './po-changes/po-changes';
import MentionsMessages from './mentions-messages/mentions-messages';
import { dateRegex, getUserTimeZoneDateFormat } from '../../helpers/dateHelper';
import NotificationItem from './notification-item';

export const giveProfile = (profileType) => {
  let profile = '';
  switch (profileType) {
    case 'buyer':
      profile = 'supplier';
      break;
    case 'supplier':
      profile = 'buyer';
      break;
    default:
      profile = profileType;
      break;
  }
  return profile;
};

function NotificationList({
  closeNotification,
  value,
  toggleState,
  show,
  refetchNotiCount,
}) {
  const { relation } = useParams();
  const [handleUpdateOrderItem] = useMutation(UPDATE_ORDERITEMS);
  const [handleBookingAcceptReject] = useMutation(
    MUTATION_BOOKING_ACCEPT_REJECT
  );
  const profile = giveProfile(toggleState);
  const hostUrl = `${window.location.protocol}//${window.location.host}`;

  const [markRead, setMarkRead] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [showUnread, setShowUnread] = useState(false);

  const chatHost = `${URLConst.host}/v1/`;

  const [showData, setShowData] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const notificationContainer = useRef(null);
  const [notificationPage, setNotificationPage] = useState({
    index: 1,
    available: true,
    perPage: 100,
  });
  const [t] = useTranslation('notifications');
  // const [toggleButton, setToggleButton] = useState(false);

  const getNotification = async (more, event, unreadState) => {
    try {
      if (more) {
        setNotificationPage((prevState) => ({
          ...prevState,
          index: prevState.index + 1,
          available: event === 'toggled' ? true : prevState.available,
        }));
      } else {
        let ntfIndex = notificationPage.index + 1;
        if (event === 'markAllRead') {
          ntfIndex = notificationPage.index;
        }

        setNotificationPage({
          ...notificationPage,
          index: ntfIndex,
          available: event === 'toggled' ? true : notificationPage.available,
        });
      }
      if (notificationPage.available === true || event === 'toggled') {
        const NotificationData = await http.get(
          `${chatHost}notifications/alllist?page=${
            event === 'toggled' ? 1 : notificationPage.index
          }&perPage=${notificationPage.perPage}${
            unreadState ? '&filterList=true' : ''
          }${
            value ? `&notificationType=${value}` : '&notificationType=general'
          }${toggleState && `&profileType=${profile}`}`
        );

        if (more) {
          setShowData([...showData, ...NotificationData.data.data]);
        } else {
          setShowData([...NotificationData.data.data]);
        }
        if (notificationContainer && event === 'toggled') {
          notificationContainer.current.scrollTop = 0;
        }
      }
      setShowLoader(false);
    } catch (error) {
      if (error?.response?.status === 401) {
        await tokenGeneration();
        setShowLoader(true);
      }
      setShowLoader(false);
      if (error.response && error.response.status === 404) {
        if (event === 'toggled') {
          setShowData([]);
        }
        setNotificationPage({
          ...notificationPage,
          available: false,
        });
      }
    }
  };

  useEffect(() => {
    setShowLoader(true);
    if (showUnread && markRead) {
      getNotification(false, 'toggled', true);
    } else if (markRead) {
      getNotification(false, 'markAllRead', false);
    } else {
      getNotification(false, '', false);
    }
  }, [markRead]);

  const handleShowUnread = (e) => {
    setShowUnread(e.target.checked);
    if (e.target.checked) {
      getNotification(false, 'toggled', true);
    } else {
      getNotification(false, 'toggled', false);
    }
  };

  const handleMarkAsRead = async () => {
    await http
      .post(`${chatHost}notifications/markAllasRead`, {
        notificationType: [value],
        profileType: profile,
      })
      .then((res) => {
        setMarkRead(true);
        refetchNotiCount();
        return res.data;
      });
  };

  const getMoreNotifications = async () => {
    setIsFetching(true);
    await getNotification(true, '', showUnread);
    setIsFetching(false);
  };

  const srcollHandler = (e) => {
    const bottom =
      e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight;
    if (bottom < 1 && showLoader === false) {
      getMoreNotifications();
    }
  };

  const saveAcceptRejectNotification = (
    Status,
    itemCodeList,
    poId,
    actionTakenFrom
  ) => {
    if (actionTakenFrom === 'order') {
      handleUpdateOrderItem({
        variables: {
          input: {
            id: poId,
            module: 'order',
            lineItemId: itemCodeList,
            statusName: Status,
            statusDate: new Date(),
            profileType: giveProfile(relation),
          },
        },
        onCompleted: async (data) => {
          toast.success(data.updateOrderItem.message);
          await readChannelNotifications(poId, 'order');
        },
      });
    }
    if (actionTakenFrom === 'booking') {
      handleBookingAcceptReject({
        variables: {
          input: {
            status: Status,
            bookingIds: itemCodeList,
          },
        },
        onCompleted: async (data) => {
          toast.success(data.bookingAcceptReject.message);
          await readChannelNotifications(itemCodeList, 'booking');
        },
      });
    }
  };

  const getTextByCond = (text, itm) => {
    let replaceText = text;
    const arrDateFilter = text
      ?.split(' ')
      ?.filter((str) => str.match(dateRegex));
    if (text?.split(' ').includes('Accepted')) {
      replaceText = `${replaceText.replace(
        'Accepted',
        '<span class="text-success">Accepted</span> '
      )} `;
    }
    if (text?.split(' ').includes('Rejected')) {
      replaceText = `${replaceText.replace(
        'Rejected',
        '<span class="text-danger">Rejected</span> '
      )} `;
    }
    if (arrDateFilter?.length > 0) {
      arrDateFilter?.forEach((dateData) => {
        replaceText = replaceText.replace(
          dateData,
          getUserTimeZoneDateFormat(dateData?.split('Date')?.[1])
        );
      });
    }
    if (
      text
        ?.split(' ')
        ?.map((word) => word.replace(/[^\w-]/g, '')) // Remove punctuation
        ?.includes(itm?.relationNo) ||
      text.includes(itm?.relationNo)
    ) {
      if (itm?.notificationId) {
        replaceText = replaceText?.replace(
          itm?.relationNo,
          ` <a class="link" href=${hostUrl}/${itm?.link}?notificationId=${itm?.notificationId}>
            ${itm?.relationNo}
          </a>`
        );
      }
    } else if (
      text?.includes(itm?.notificationData?.customizeData?.count) &&
      itm?.type === 'myConsole'
    ) {
      replaceText = replaceText?.replace(
        itm?.notificationData?.customizeData?.count,
        ` <a class="link" href=${hostUrl}/${itm?.link}>
            ${itm?.notificationData?.customizeData?.count}
          </a>`
      );
    } else {
      replaceText = `${text} `;
    }
    return replaceText;
  };

  return (
    <OutsideClick onClickOutside={closeNotification}>
      <div className="notification-list-container">
        <div className="notification-list-heder">
          <h3 className="notification-list-title">
            {t('notifications.title')}
          </h3>
          <div className="notification-list-heder-right">
            {show && (
              <label
                className="notification-switch"
                htmlFor="switchNotification"
              >
                <input
                  value="unread"
                  type="checkbox"
                  onClick={handleShowUnread}
                  id="switchNotification"
                  checked={showUnread}
                />
                <span className="wrapper">
                  <span className="switch-label">
                    {t('notifications.showonlyunread')}
                  </span>
                  <span className="switch-bg">
                    <span className="ball" />
                  </span>
                </span>
              </label>
            )}
          </div>
        </div>
        <div className="notification-list-tab">
          <div className="notification-list-tab-buttons">
            {!value && <label>Milestone</label>}
            {value && value !== 'chat' && (
              <label>
                {t(`notifications.${value}`)} {t('notifications.notifications')}
              </label>
            )}
          </div>
          {show && (
            <div className="notification-list-tab-buttons align-center">
              {showData.length !== 0 && (
                <button type="button" onClick={handleMarkAsRead}>
                  <AcceptIcon color="#333333" />
                  {t('notifications.markallasread')}
                </button>
              )}
            </div>
          )}
        </div>

        <div
          className="notification-list-body"
          onScroll={srcollHandler}
          ref={notificationContainer}
        >
          {!['poChange', 'chat', 'mention'].includes(value) && !showLoader ? (
            <ul className="notification-list">
              {showData.length === 0 ? (
                <div>
                  {value === 'actionable' && (
                    <NoData
                      image={
                        <ActionableNotificationNoDataIcon
                          Width="100%"
                          Height="13.889vw"
                        />
                      }
                    />
                  )}
                  {value === 'approval' && (
                    <NoData
                      image={
                        <ResponceNotificationNoDataIcon
                          Width="100%"
                          Height="13.889vw"
                        />
                      }
                    />
                  )}
                  {value === 'document' && (
                    <NoData
                      image={
                        <DocumetsNotificationNoDataIcon
                          Width="100%"
                          Height="13.889vw"
                        />
                      }
                    />
                  )}
                  {value !== 'actionable' &&
                    value !== 'approval' &&
                    value !== 'document' && (
                      <NoData
                        image={
                          <AllNotificationNoDataIcon
                            Width="100%"
                            Height="13.889vw"
                          />
                        }
                      />
                    )}
                </div>
              ) : (
                showData?.map((item) => {
                  return item.notificationType !== 'document' ? (
                    <NotificationItem
                      item={item}
                      saveAcceptRejectNotification={
                        saveAcceptRejectNotification
                      }
                      getTextByCond={getTextByCond}
                      t={t}
                    />
                  ) : (
                    <DocumentItem data={item} t={t} />
                  );
                })
              )}

              {isFetching && (
                <li>
                  <div className="notification-item loader">
                    <span className="time">
                      <Skeleton
                        skHeight="0.556vw"
                        skWidth="3.472vw"
                        skMargin="0.417vw 0 0"
                      />
                    </span>
                    <div className="user-image">
                      <Skeleton
                        skHeight="2.639vw"
                        skWidth="2.639vw"
                        skRadius="50%"
                        skMargin="0 0 0.694vw"
                      />
                    </div>
                    <div className="details">
                      <p>
                        <Skeleton
                          skHeight="0.833vw"
                          skWidth="13.889vw"
                          skMargin="0 0 0.278vw"
                          skRadius="0.694vw"
                        />
                        <Skeleton
                          skHeight="0.833vw"
                          skWidth="10.417vw"
                          skRadius="0.694vw"
                        />
                      </p>
                      <Skeleton
                        skHeight="0.833vw"
                        skWidth="17.361vw"
                        skRadius="0.694vw"
                      />
                    </div>
                  </div>
                </li>
              )}
              {!notificationPage.available &&
              showData.length > 0 &&
              value !== 'actionable' &&
              value !== 'approval' &&
              value !== 'document' ? (
                <li>
                  <div className="notification-item text-center align-center">
                    <p className="mb-0">
                      {t('notifications.noNewNotifications')}
                    </p>
                  </div>
                </li>
              ) : null}
            </ul>
          ) : (
            showLoader && (
              <ul className="notification-list">
                {[...Array(7)]?.map(() => {
                  return (
                    <li>
                      <div className="notification-item loader">
                        <span className="time">
                          <Skeleton
                            skHeight="0.556vw"
                            skWidth="3.472vw"
                            skMargin="0.417vw 0 0"
                          />
                        </span>
                        <div className="user-image">
                          <Skeleton
                            skHeight="2.639vw"
                            skWidth="2.639vw"
                            skRadius="50%"
                            skMargin="0 0 0.694vw"
                          />
                        </div>
                        <div className="details">
                          <p>
                            <Skeleton
                              skHeight="0.833vw"
                              skWidth="13.889vw"
                              skMargin="0 0 0.278vw"
                              skRadius="0.694vw"
                            />
                            <Skeleton
                              skHeight="0.833vw"
                              skWidth="10.417vw"
                              skRadius="0.694vw"
                            />
                          </p>
                          <Skeleton
                            skHeight="0.833vw"
                            skWidth="17.361vw"
                            skRadius="0.694vw"
                          />
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
            )
          )}
          {value === 'poChange' &&
            (showData.length > 0 ? (
              <PoChangesGroup data={showData} translate={t} />
            ) : (
              <NoData
                image={<POChangesNoData Width="100%" Height="13.889vw" />}
              />
            ))}
          {value === 'chat' &&
            (showData.length > 0 ? (
              <MentionsMessages
                data={showData}
                t={t}
                closeNotification={closeNotification}
              />
            ) : (
              <NoData image={<ChatNoData Width="100%" Height="13.889vw" />} />
            ))}
        </div>
      </div>
    </OutsideClick>
  );
}

function mapStateToProps(state) {
  return {
    toggleState: state.omniState.toggleState,
  };
}

NotificationList.propTypes = {
  closeNotification: PropTypes.func,
  toggleState: PropTypes.string,
  value: PropTypes.string,
  show: PropTypes.bool,
  refetchNotiCount: PropTypes.func,
};
NotificationList.defaultProps = {
  closeNotification: () => {},
  value: '',
  toggleState: '',
  show: false,
  refetchNotiCount: () => {},
};

export default connect(mapStateToProps, null)(NotificationList);
